import { normalizeParentFiles } from 'tools/Files/normalize'
import { normalizeTags2 } from 'tools/SelectTags'
import { put } from 'utils/dict'
import { freeze } from 'utils/dom'
import { strcmp } from 'utils/string'
import { formatDate } from 'utils/time'

import { normalizeJourneyActor } from 'app/Journey/lib/journeyActor'
import { DISCUSS_TYPES, routeToType } from 'libreon/Discuss/normalize'
import { normalizeUser } from 'libreon/User/lib'

////////////////////////////////////////////////////////////////////////////////
export const defaultProject = {
  id: undefined,
  shortId: undefined,
  title: '',
  profile: {},
  // tabs,
  // tabProps: { xctivity: {} },
  data: [],
  d: {},
  purchase: [],
  praise: [],
  members: [],
  invites: [],
  files: [],
  filesL: [],
  fileTypes: {},
  tagsD: { tags: {}, types: {} },
  // journeyLinksL: [],
  // journeyLinksD: {},
  // journeys: [],
  // milestones: [],
  // milestonesD: {},
  // milestonesL: [],
  // // come in from a second query to reactorChallengeInputGroups
  // challengesL: [],
  // challengesD: {},
  requests: [],
  discuss: [],
  discussTypes: {},
  discussClubMap: {},
  summary: { comments: [] },
  browse: undefined,
  showJourney: window.location.search.includes('showJourney'),
  canEdit: false,
  canView: false,
  canUsers: false,
  can: {},
  avatar: { default: true },
  allows: () => false,
  rating: undefined,
  license: {},
  status: '',
  format: '',
  website: '',
  elevator: '',
  refresh: 0
}

export function normalizeProject(project, orig = {}) {
  let d = (project.data || []).reduce((d, p) => {
    d[p.type] = { ...p, ...p.value }
    return d
  }, {})

  const profile = d.profile?.value ?? {}

  project = {
    ...defaultProject,
    ...orig,
    ...project,
    d,
    releaseDate: formatDate(project.releasedAt),
    releasedAt_t: +new Date(project.releasedAt) || 0,
    updatedAt_t: +new Date(project.updatedAt) || 0,
    profile: profile,
    elevator: profile.elevator ?? '',
    purchase: [...(d.purchase?.value ?? [])],
    praise: [...(d.praise?.value ?? [])],
    needs: {
      value: {},
      roles: [...(d?.roles || [])].toSorted(strcmp)
    },
    license: d?.license || { quota: 50 * 1024 * 1024, storage: 0, value: {} },
    contribs: d?.contribs || {},
    ...normalizeProjectJourneyActor(project)
  }

  project = normalizeParentFiles(project, project.files)
  if (project.tags) {
    project.tagsD = normalizeTags2(project.tags)
    delete project.tags
  }

  let active = []
  let inactive = []

  if (project.invites?.length) {
    active.push('members')
  } else {
    inactive.push('members')
  }

  project.members = (project?.members || []).map(normalizeProjectMember)

  if (project.pd?.length > 0) {
    const { types, map, sum } = project.pd.reduce(
      ({ types, map, sum }, d) => {
        const type = routeToType(d.type)
        const typeKey = type.description

        switch (type) {
          case DISCUSS_TYPES.PROJ_CLUB:
            // book club is a list of forums
            if (!types[typeKey]) {
              types[typeKey] = []
            }
            types[typeKey].push(d)

            // and add it to our map for bookclub
            map[d.id] = d
            map[d.shortId] = d

            // and summarize it too
            sum = Object.keys(d.discuss.summary).reduce((sum, key) => {
              sum[key] = d.discuss.summary[key] + (sum[key] || 0)
              sum.total++

              return sum
            }, sum)

            break

          default:
            types[typeKey] = d
            break
        }

        return { types, map, sum }
      },
      { types: {}, map: {}, sum: { total: 0 } }
    )

    project.discussTypes = types
    project.discussClubMap = map
    project.discussClubSum = sum
  }

  project.refresh++
  project._ready = project.journeyLinksL?.length > 0
  // project._enriched = false // causes too many refreshes; notably for useQueryTag stuffs
  project._normal = true
  return project
}

export function normalizeProjectAccess(project, user) {
  if (!project._enriched && project.myAccess && user?.canGlobally) {
    project = { ...project }
    // const isAdmin = user.is('superadmin') // TODO: fix/remove
    project.myAccess = new Set(project.myAccess)
    project.allows = (action) =>
      project.myAccess.has(action) || user.canGlobally(action)
    project.isMember = project.members.some(({ user: { id } }) => id === user.id)
    project.canEdit = project.allows('project_edit')
    project.canView = project.allows('answer_edit')
    project.canUsers = project.allows('user_edit')
    project.can = {
      view: project.canView,
      edit: project.canEdit,
      answerRead: project.allows('answer_view'),
      answerWrite: project.allows('answer_edit')
    }
    project._enriched = true
  }
  return freeze(project)
}

function normalizeProjectMember(member) {
  return { ...member, user: normalizeUser(member.user) }
}

function normalizeProjectJourneyActor({ journeyActor }) {
  let journeyLinksL = []
  let journeyLinksD = {}
  let journeys = []
  let journeysD = {}
  let milestones = []
  let milestonesD = {}

  if (journeyActor) {
    let { journeys, id, type } = journeyActor
    if (journeys.length > 0) {
      journeyLinksL = journeys.map((m) => m.id)
      journeyLinksD = [...journeys].reduce(
        (dict, jMap) => put(dict, jMap.id, normalizeJourneyActor(jMap)),
        {}
      )

      // journeys turns into just the IDs
      // this isn't great and should be refactored out eventually
      journeysD = journeys.reduce((acc, jm) => {
        acc[jm.journey.id] = jm.journey
        return acc
      }, {})
      journeys = journeys.map((jm) => jm.journey.id)

      // some shenanagins to avoid showing duplicate ribbons
      milestones = journeyLinksL.reduce(
        ({ dups, m }, jmapId) => {
          const jm = journeyLinksD[jmapId]
          const ms = jm.milestone
          if (ms) {
            const k = `${ms.name}.${ms.meta.style.primary}.${ms.meta.style.text}`
            if (!dups[k]) {
              dups[k] = true
              m.push(ms)
            }
          }
          return { dups, m }
        },
        { dups: {}, m: [] }
      ).m

      milestonesD = journeyLinksL.reduce((mDict, jmapId) => {
        const {
          journey: { milestonesL = [], id }
        } = journeyLinksD[jmapId]
        return milestonesL.reduce((mDict, mId) => {
          mDict[mId] = { journeyId: id, jmapId }
          return mDict
        }, mDict)
      }, {})
    }
    journeyActor = Object.freeze({ id, type })
  } else {
    journeyActor = {}
  }

  return Object.freeze({
    journeyActor,
    journeyLinksL,
    journeyLinksD,
    journeys,
    journeysD,
    milestones,
    milestonesD
  })
}
